<template>
  <div class="container">
    <el-page-header @back="goBack">
      <template #content>
        <span class="pege-header">编辑政策法规</span>
      </template>
    </el-page-header>
    <div class="add-form">
      <el-form
        ref="ruleFormRef"
        :model="form"
        :rules="rules"
        label-width="120px"
      >
        <el-form-item label="政策法规标题" prop="title">
          <el-input
            v-model="form.title"
            maxlength="100"
            show-word-limit
            placeholder="请输入标题"
          ></el-input>
        </el-form-item>
        <el-form-item label="来源" prop="source">
          <el-input
            v-model="form.source"
            maxlength="100"
            show-word-limit
            placeholder="请输入来源"
          ></el-input>
        </el-form-item>
        <el-form-item label="政策法规内容" prop="content">
          <div class="editor">
            <editor :html="form.content" @change="change"></editor>
            <li class="length">{{ length }}/20000</li>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm()">发布</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, ref, toRefs } from "vue";
import { useRouter } from "vue-router";
import editor from "../../../components/Editor";
import utils from "../../../utils/utils";
import { ElMessage } from "element-plus";
import api from "./../../../api/index.js";
import NProgress from "nprogress";

export default {
  components: {
    editor,
  },
  setup() {
    const router = useRouter();

    const ruleFormRef = ref(null);
    let length = ref(0);
    let form = reactive({ form: {} });

    let rules = reactive({
      title: [
        {
          required: true,
          message: "请输入标题",
          trigger: "blur",
        },
      ],
      source: [
        {
          required: true,
          message: "请输入来源",
          trigger: "blur",
        },
      ],
      content: [
        {
          required: true,
          message: "请输入内容",
          trigger: "blur",
        },
        {
          validator: (rule, value, callback) => {
            checkContent(rule, value, callback);
          },
          trigger: ["blur"],
        },
      ],
    });

    const goBack = () => {
      router.go(-1);
    };

    // 查询数据
    const getData = async () => {
      const params = {
        id: router.currentRoute.value.params.id,
      };
      try {
        NProgress.start();
        const res = await api.policy.getDataInfo(params);
        NProgress.done();
        if (res.code === 10200) {
          form.form = reactive(res.data);
        } else {
          ElMessage.error(res.msg);
        }
      } catch (error) {
        NProgress.done();
      }
    };
    onMounted(() => {
      getData();
    });
    const change = (data) => {
      form.form.content = data;
      ruleFormRef.value.validateField("content");
      length.value = utils.getEditorLength(data);
    };

    const checkContent = (rule, value, callback) => {
      if (length.value > 20000) {
        return callback(new Error("不能超过20000字"));
      } else {
        callback();
      }
    };

    const submitForm = () => {
      ruleFormRef.value.validate((valid) => {
        if (valid) {
          addData();
        } else {
          return false;
        }
      });
    };

    const addData = async () => {
      try {
        NProgress.start();
        const res = await api.policy.addData(form.form);
        NProgress.done();
        if (res.code === 10200) {
          ElMessage.success("编辑成功");
          router.push("/operate/policy/statute");
        } else {
          ElMessage.error(res.msg);
        }
      } catch (error) {
        NProgress.done();
      }
    };

    return {
      goBack,
      ...toRefs(form),
      length,
      change,
      submitForm,
      rules,
      ruleFormRef,
    };
  },
};
</script>

<style lang="scss" scoped>
.pege-header {
  font-size: 0.875rem;
}

.add-form {
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid $--border-color-base;

  .el-input {
    max-width: 300px;
  }

  .editor {
    margin-bottom: -20px;
    max-width: 774px;
    .length {
      line-height: 20px;
      text-align: right;
      color: $--color-text-regular;
    }
  }
}
</style>